export default __webpack_public_path__ + "static/media/K_0218988_1_Certificaat.26381307.pdf";